/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffStoryRequest
 */
export interface PostLiffStoryRequest {
    /**
     * 
     * @type {string}
     * @memberof PostLiffStoryRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffStoryRequest
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffStoryRequest
     */
    handleName: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffStoryRequest
     */
    answererId: string;
}

/**
 * Check if a given object implements the PostLiffStoryRequest interface.
 */
export function instanceOfPostLiffStoryRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "body" in value;
    isInstance = isInstance && "handleName" in value;
    isInstance = isInstance && "answererId" in value;

    return isInstance;
}

export function PostLiffStoryRequestFromJSON(json: any): PostLiffStoryRequest {
    return PostLiffStoryRequestFromJSONTyped(json, false);
}

export function PostLiffStoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffStoryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'body': json['body'],
        'handleName': json['handleName'],
        'answererId': json['answererId'],
    };
}

export function PostLiffStoryRequestToJSON(value?: PostLiffStoryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'body': value.body,
        'handleName': value.handleName,
        'answererId': value.answererId,
    };
}

